import styled from 'styled-components';
import { colors, s64 } from '@ardoq/design-tokens';
import { Loader } from './Loader';
import { LoadingScreenLogo } from './LoadingScreenLogo';

// We are using WEB_SAFE_FONT on loading screen
// because at that moment font files are not loaded
const WEB_SAFE_FONT = [
  'Trebuchet MS',
  '-apple-system',
  'Segoe UI',
  'Roboto',
  'Noto Sans',
  'Ubuntu',
  'Cantarell',
  'Helvetica Neue',
].join(',');

const PageWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${colors.surfaceBrand};
  color: ${colors.textSubtle};
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Title = styled.div`
  font-family: ${WEB_SAFE_FONT};
  font-size: 16px;
  font-weight: 400;
  margin-top: ${s64};
  color: ${colors.textModerate};
`;

const TipText = styled.div`
  font-family: ${WEB_SAFE_FONT};
  min-height: ${s64};
  max-width: 530px;
  text-align: center;
`;

type LoadingScreenProps = {
  title?: string;
  tipText?: string;
  tipTextId?: string;
};

export const LoadingScreen = ({
  title = 'We’re preparing your data...',
  tipText,
  tipTextId,
}: LoadingScreenProps) => (
  <PageWrapper>
    <LoadingScreenLogo color={colors.iconBrand} />
    <ContentWrapper>
      <Title>{title}</Title>
      <Loader />
      {tipTextId && <TipText id={tipTextId} />}
      {tipText && <TipText>{tipText}</TipText>}
    </ContentWrapper>
  </PageWrapper>
);
